import * as api from '../api';
import {sendMessage} from "../api";

export function smsD3(event, to, texte) {
    let data;
    data = {
            	"event": event,
            	"message_type_id": 6,
            	"lang": "FR",
            	"to": to,
                "country": 76,
            	"data": {
            		"txt-D3": texte
            	}
            };
    return api.sendMessage(data)
        .then((result) => {
console.log(result);

        })
        .catch((error) => {
            console.error("Erreur smsD3:", error);
            throw error;
        });
}
